// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container_3EUVG","links_container":"main_links_container_3TXYy","wrapper":"main_wrapper_3n-UA"};